module.exports = __webpack_public_path__ + "static/media/classroom_nav.978b1454.svg";